<template>
  <div class="Dashbord" ref="document">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <!-- color="#fffff" -->
    <div class="Actions__Content" style="padding: 10px">
      <div class="DataTable">
        <div fluid style="padding-top: 10px; padding-bottom: 10px">
          <v-form ref="form">
            <v-layout
              row
              wrap
              style="padding-top: 0px !important; max-height: 1000px !important"
            >
              <v-flex
                xs2
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <!-- <v-text-field
                  v-model="godina"
                  label="Godina"
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  required
                  type="number"
                ></v-text-field> -->
                <v-autocomplete
                  v-model="godina_select"
                  :items="godina_items"
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  label="Godina berbe"
                  required
                  ref="element11"
                  clearable
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs9 pa-2> </v-flex>
              <v-flex xs1 style="text-align: right">
                <v-btn
                  @click="submitKartice"
                  class="AppButtonFilled"
                  style="margin-top: 15px"
                  >Pretraži</v-btn
                >
              </v-flex>
            </v-layout>

            <v-layout> </v-layout>
            <v-layout
              row
              wrap
              style="padding-top: 0px !important; max-height: 1000px !important"
            >
              <v-flex
                xs3
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="vineyard_select"
                  :items="vineyard_items"
                  item-text="name"
                  item-value="id"
                  :label="labVinograd"
                  persistent-hint
                  return-object
                  hide-no-data
                  outlined
                  dense
                  clearable
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  v-on:change="getGrapeVarieties"
                  required
                >
                </v-autocomplete>
              </v-flex>
              <v-flex
                xs3
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="grape_varieties_to_select"
                  :items="grape_varieties_to_items"
                  item-text="name"
                  item-value="id"
                  label="Sorta"
                  persistent-hint
                  return-object
                  hide-no-data
                  clearable
                  outlined
                  dense
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  required
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs3 pa-2>
                <v-checkbox
                  id="makarije"
                  label="Prikaži količinu đubriva"
                  v-model="prikazi"
                  :checked="prikazi"
                  v-on:change="sakriFiltere"
                ></v-checkbox>
              </v-flex>
              <v-flex
                xs2
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              ></v-flex>
              <v-flex
                xs1
                style="
                  text-align: center;
                  margin-bottom: 0px;
                  padding-left: 30px;
                "
              >
                <v-btn @click="stampaj" fab small
                  ><img
                    src="../assets/menuIcons/ico-print.png"
                    title="Štampa dokumenta"
                /></v-btn>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <div class="zaglavlje">Godina sadnje: {{ planting_years }}</div>
          </v-layout>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <div class="text">Uzgojni oblik: {{ breeding_type }}</div>
          </v-layout>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <div class="text">Vrsta rezidbe: {{ pruning_type }}</div>
          </v-layout>

          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <div class="zaglavlje_2">Đubrenje</div>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-data-table
                :headers="headers_states_fertilization"
                :items="items_states_basic"
                class="TankTable"
                item-key="rbr"
                ref="dTable"
                :pagination.sync="paginationKartica"
                style="padding-top: 10px"
                hide-actions
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{ props.item.rbr }}
                  </td>

                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{ formatDateTime(props.item.date) }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{ props.item.name }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{ props.item.material }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="prikazi"
                  >
                    {{ props.item.quantity }}
                  </td>
                  <td style="width: 50px"></td>
                </template>
                <template slot="pageText" slot-scope="item">
                  {{ item.pageStart }} - {{ item.pageStop }} od
                  {{ item.itemsLength }}
                </template>
                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <div class="zaglavlje_3">Feno faza</div>
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-data-table
                :headers="headers_states"
                :items="items_states_pheno_phases"
                class="TankTable"
                item-key="id"
                ref="dTable"
                :pagination.sync="paginationKarticaFF"
                style="padding-top: 10px"
                hide-actions
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKarticaFF.descending ? 'desc' : 'asc',
                        header.value === paginationKarticaFF.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                    >
                      <!-- @click="changeSortKartica(header.value)" -->
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 20%;
                    "
                  >
                    {{
                      items_states_pheno_phases
                        .map(function (x) {
                          return x.id;
                        })
                        .indexOf(props.item.id) + 1
                    }}
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 20%;
                    "
                  >
                    {{ props.item.name }}
                  </td>

                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 20%;
                    "
                  >
                    {{ formatDateTime(props.item.from) }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 30%;
                    "
                  >
                    {{ formatDateTime(props.item.to) }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 10%;
                    "
                  ></td>
                </template>
                <!-- <template slot="pageText" slot-scope="item">
                  {{ item.pageStart }} - {{ item.pageStop }} od
                  {{ item.itemsLength }}
                </template> -->
                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <div class="zaglavlje_3">Obrada zemljišta</div>
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-data-table
                :headers="headers_states"
                :items="items_states_land_cultivations"
                class="TankTable"
                item-key="id"
                ref="dTable"
                :pagination.sync="paginationKartica"
                style="padding-top: 10px"
                hide-actions
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                    >
                      <!-- @click="changeSortKartica(header.value)" -->
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 20%;
                    "
                  >
                    {{
                      items_states_land_cultivations
                        .map(function (x) {
                          return x.id;
                        })
                        .indexOf(props.item.id) + 1
                    }}
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 20%;
                    "
                  >
                    {{ props.item.name }}
                  </td>

                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 20%;
                    "
                  >
                    {{ formatDateTime(props.item.from) }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 30%;
                    "
                  >
                    {{ formatDateTime(props.item.to) }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 10%;
                    "
                  ></td>
                </template>
                <template slot="pageText" slot-scope="item">
                  {{ item.pageStart }} - {{ item.pageStop }} od
                  {{ item.itemsLength }}
                </template>
                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <div class="zaglavlje_2">Berba</div>
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-data-table
                :headers="headers_states_harvests"
                :items="items_states_harvests"
                class="TankTable"
                item-key="id"
                ref="dTable"
                :pagination.sync="paginationKartica"
                style="padding-top: 10px"
                hide-actions
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                    >
                      <!-- @click="changeSortKartica(header.value)" -->
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{
                      items_states_harvests
                        .map(function (x) {
                          return x.id;
                        })
                        .indexOf(props.item.id) + 1
                    }}
                  </td>

                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{ formatDateTime(props.item.date) }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{ props.item.quantity }} kg
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{
                      props.item.surface > 1000
                        ? currencyFormatDE4(props.item.surface / 10000) + " ha"
                        : currencyFormatDE4(
                            Math.round(props.item.surface) / 100
                          ) + " ar"
                    }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{
                      currencyFormatDE3(
                        props.item.quantity / (props.item.surface / 10000)
                      )
                    }}
                    kg/ha
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{ props.item.sugar }} °Oe
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{ props.item.acid }} g/l
                  </td>
                  <td style="width: 50px"></td>
                </template>
                <template slot="pageText" slot-scope="item">
                  {{ item.pageStart }} - {{ item.pageStop }} od
                  {{ item.itemsLength }}
                </template>
                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>

        <script>
import { serverBus } from "../main";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TokenComponent from "../components/Token";
import {
  readJSON,
  prevediOperacije3,
  currencyFormatDE,
  getDateTime,
  daLiJeVinarija
} from "../helpers/Functions";

import html2pdf from "html2pdf.js";

export default {
  props: ["operationType"],
  name: "Maka",
  dialog: false,
  components: {
    TokenComponent,

    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,

      headers_states: [
        { text: "Rb." },
        {
          text: "Naziv",
          value: "grape_variety",
          align: "center",
          sortable: true,
        },
        {
          text: "Početak",
          value: "from",
          align: "right",
          sortable: true,
        },
        {
          text: "Kraj",
          value: "to",
          align: "right",
          sortable: true,
        },
        {
          text: "",
        },
      ],
      headers_states_fertilization: [
        { text: "Rb." },
        {
          text: "Datum",
          value: "date",
          align: "right",
        },
        { text: "Naziv", value: "name", align: "right" },
        { text: "Materijal", value: "name", align: "right" },
        { text: "Količina", value: "name", align: "right" },
        {
          text: "",
        },
      ],
      headers_states_harvests: [
        { text: "Rb." },
        {
          text: "Datum",
          value: "date",
          align: "right",
          sortable: true,
        },
        { text: "Količina", value: "quantity", align: "right" },
        { text: "Površina", value: "surface", align: "right" },
        { text: "Prinos", value: "", align: "right" },
        { text: "Šećer", value: "sugar", align: "right" },
        { text: "Kiselina", value: "acid", align: "right" },
        {
          text: "",
        },
      ],
      items_states_basic: [],
      items_states_harvests: [],
      items_states_pheno_phases: [],
      items_states_land_cultivations: [],
      listSize: [5, 10, 25, 50, 100, { text: "Svi", value: 1000000 }],
      paginationKartica: {
        sortBy: "id",
        descending: true,
        rowsPerPage: 25,
        descending: false,
      },
      paginationKarticaFF: {
        sortBy: "from",
        descending: true,
        rowsPerPage: 25,
        descending: false,
      },
      search: "",
      izabranaStranica: 0,
      grape_varieties_to_select: undefined,
      grape_varieties_to_items: [],
      vineyard_items: [],
      vineyard_select: undefined,
      godina_items: [],
      godina_select: undefined,
      godina: undefined,
      loading: true,
      headers_modal: [
        {
          text: "Izabrani redovi",
          value: "tankNumberInBatch",
          align: "center",
        },
      ],
      headers_modal_sorta: [
        { text: "Izabrane sorte", value: "tankNumberInBatch", align: "center" },
      ],

      vinogradiFilter: "",
      filterSorti: "",
      json_data: [],
      json_data_ff: [],
      json_data_oz: [],
      json_data_be: [],
      json_fields_type: [],
      json_fields_type_ff: [],
      json_fields_type_be: [],
      json_fields: {
        Rb: "String",
        Datum: "String",
        Naziv: "String",
        Materijal: "String",
        Količina: "String",
      },
      json_fields_ff: {
        Rb: "String",
        Naziv: "String",
        Početak: "String",
        Kraj: "String",
      },
      json_fields_be: {
        Rb: "String",
        Datum: "String",
        Količina: "String",
        Površina: "String",
        Prinos: "String",
        Šećer: "String",
        Kiseline: "String",
      },
      planting_years: "",
      pruning_type: "",
      breeding_type: "",

      prikazi: false,
      labVinograd: "",
      naslov: ""
    };
  },
  // computed: {
  //   params(nv) {
  //     return {
  //       ...this.paginationKartica,
  //       query: this.search,
  //     };
  //   },
  // },
  watch: {
    params: {
      handler(newVal, oldVal) {
        if (this.operationType !== undefined)
          if (
            (newVal.page !== oldVal.page ||
              newVal.rowsPerPage !== oldVal.rowsPerPage ||
              newVal.sortBy !== oldVal.sortBy ||
              newVal.descending !== oldVal.descending) &&
            newVal.sortBy !== ""
          ) {
            this.izabranaStranica = this.paginationKartica.page - 1;

            if (this.vineyard_items.length === 0) this.getVineYards();
            // if (this.grape_varieties_to_items.length === 0)
            //   this.getGrapeVarieties();

            // this.getAllKartice();
          }
      },
      deep: true,
    },
    operationType: function (val) {
      this.clear();
      // this.items_states = [];

      if (val !== null && val !== undefined) {
        this.getVineYards();
        // this.getGrapeVarieties();
        // this.getAllKartice();
      }
    },
  },

  methods: {
    currencyFormatDE3(num) {
      return (
        num
          .toFixed(3) // always two decimal digits
          // .replace(",", "") // replace decimal point character with ,
          .replace(".", ",")
      ); // replace decimal point character with ,
      // .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
    },
    sakriFiltere(a) {
      if (a) {
        this.headers_states_fertilization = [
          { text: "Rb." },
          {
            text: "Datum",
            value: "date",
            align: "right",
            sortable: true,
          },
          { text: "Naziv", value: "name", align: "right" },
          { text: "Materijal", value: "name", align: "right" },
          { text: "Količina", value: "name", align: "right" },
          {
            text: "",
          },
        ];
      } else {
        this.headers_states_fertilization = [
          { text: "Rb." },
          {
            text: "Datum",
            value: "date",
            align: "right",
            sortable: true,
          },
          { text: "Naziv", value: "name", align: "right" },
          { text: "Materijal", value: "name", align: "right" },
          {
            text: "",
          },
        ];
      }
    },
    currencyFormatDE4(num) {
      return (
        num
          .toFixed(4) // always two decimal digits
          // .replace(",", "") // replace decimal point character with ,
          .replace(".", ",")
      ); // replace decimal point character with ,
      // .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
    },
    prevediOperacije3lok(text) {
      return prevediOperacije3(text);
    },
    submitKartice() {
      if (this.$refs.form.validate()) this.getAllKartice();
    },
    getYears() {
      let url = "";

      url =
        this.globalServiceLocation +
        this.globalPort +
        "/vineyard_operation_execution/grape_operation_years";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.godina_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      this.godina_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join("."); // + " " + [HH, mm].join(":");
      } else return "";
    },
    stampaj() {
      if (this.naslov === undefined) alert("Učitajte podatke");
      else {
        let _this = this;
        this.isLoading = true;

        setTimeout(() => {
          var elementToPrint = document.createElement("div");
          elementToPrint.style.margin = "0px 0px 0px 0px";

          var elementToPrint2 = document.createElement("p");
          elementToPrint2.innerHTML = _this.naslov;

          elementToPrint2.style.position = "relative";
          elementToPrint2.style.textAlign = "center";
          elementToPrint2.style.fontSize = "20px";
          elementToPrint.append(elementToPrint2);

          if (_this.vinogradiFilter !== "" || _this.filterSorti !== "") {
            let pomocni_tekst = "";

            pomocni_tekst = pomocni_tekst + "Godina: " + _this.godina_select;
            pomocni_tekst = pomocni_tekst + "<br>";

            if (_this.vinogradiFilter !== "") {
              pomocni_tekst =
                pomocni_tekst +
                _this.labVinograd + ": " +
                _this.vinogradiFilter.substring(
                  0,
                  _this.vinogradiFilter.length - 2
                );
              pomocni_tekst = pomocni_tekst + "<br>";
            }

            if (_this.filterSorti !== "") {
              pomocni_tekst =
                pomocni_tekst +
                "Sorta: " +
                _this.filterSorti.substring(0, _this.filterSorti.length - 2);
              pomocni_tekst = pomocni_tekst + "<br>";
            }

            pomocni_tekst =
              pomocni_tekst + "Godina sadnje: " + _this.planting_years;
            pomocni_tekst = pomocni_tekst + "<br>";

            pomocni_tekst =
              pomocni_tekst +
              "Uzgojni oblik: " +
              (_this.breeding_type === null ? "" : _this.breeding_type);
            pomocni_tekst = pomocni_tekst + "<br>";
            pomocni_tekst =
              pomocni_tekst +
              "Vrsta rezidbe: " +
              (_this.pruning_type === null ? "" : _this.pruning_type);
            pomocni_tekst = pomocni_tekst + "<br>";
            var elementToPrint1 = document.createElement("p");

            elementToPrint1.innerHTML = pomocni_tekst + " <br>";

            elementToPrint1.style.margin = "5px 0px 0px 0px";
            elementToPrint1.style.fontSize = "14px";
            elementToPrint.append(elementToPrint1);
          }

          var elementToPrint10 = document.createElement("p");

          elementToPrint10.innerHTML = "Đubrenje <br><br>";

          elementToPrint10.style.margin = "5px 0px 0px 0px";
          elementToPrint10.style.fontSize = "14px";
          elementToPrint.append(elementToPrint10);

          var tbl = document.createElement("table");
          var tr = document.createElement("tr"); // Header row

          jQuery.each(_this.json_fields, function (i, val) {
            var th = document.createElement("th"); //column
            var text = "";
            text = document.createTextNode(i);

            th.setAttribute("style", "padding-bottom: 4px;");

            th.appendChild(text);

            if (i === "Količina" && _this.prikazi) tr.appendChild(th);
            else if (i !== "Količina") tr.appendChild(th);
          });

          tr.style.background = "#eaece5";
          tbl.appendChild(tr);

          var tblBody = document.createElement("tbody");

          if (_this.json_data.length > 0)
            jQuery.each(_this.json_data, function (i, val1) {
              var row = document.createElement("tr");

              let pomJ = 0;

              jQuery.each(val1, function (i, val) {
                var cell = document.createElement("td");

                var cellText;

                if (val === null || val === 0 || val === "")
                  cellText = document.createTextNode("-");
                else cellText = document.createTextNode(val);

                cell.appendChild(cellText);

                if (i === 1)
                  cell.setAttribute(
                    "style",
                    "text-align :left; padding-left: 5px; padding-bottom: 4px;"
                  );
                else if (_this.json_fields_type[pomJ] === "Number") {
                  cell.setAttribute(
                    "style",
                    "text-align :right; padding-bottom: 4px; padding-right: 5px;"
                  );
                } else if (_this.json_fields_type[pomJ] === "Date") {
                  cell.setAttribute(
                    "style",
                    "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
                  );
                } else
                  cell.setAttribute(
                    "style",
                    "text-align :center; padding-bottom: 4px;"
                  );

                pomJ = pomJ + 1;

                if (pomJ === 5 && _this.prikazi) row.appendChild(cell);
                else if (pomJ !== 5) row.appendChild(cell);
              });

              tblBody.appendChild(row);
            });
          else {
            var row = document.createElement("tr");
            for (let i = 0; i < 3; i++) {
              var cell = document.createElement("td");
              var cellText = document.createTextNode("-");

              cell.appendChild(cellText);

              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

              row.appendChild(cell);
            }

            tblBody.appendChild(row);
          }
          tbl.setAttribute("border", "thin solid");
          tbl.style.borderCollapse = "collapse";
          // tbl.style.borderColor = "black";

          tbl.appendChild(tblBody);

          tbl.style.margin = "0px 0px 0px 0px";
          tbl.style.width = "100%";

          elementToPrint.appendChild(tbl);

          // tblBody.appendChild(poslednjiRed);

          /////// Feno faze ///////

          var elementToPrint11 = document.createElement("p");

          elementToPrint11.innerHTML = "<br>Feno faze <br><br>";

          elementToPrint11.style.margin = "5px 0px 0px 0px";
          elementToPrint11.style.fontSize = "14px";
          elementToPrint.append(elementToPrint11);

          tbl = document.createElement("table");
          tr = document.createElement("tr"); // Header row
          jQuery.each(_this.json_fields_ff, function (i, val) {
            var th = document.createElement("th"); //column
            var text = "";
            text = document.createTextNode(i);

            th.setAttribute("style", "padding-bottom: 4px;");

            th.appendChild(text);

            tr.appendChild(th);
          });

          tr.style.background = "#eaece5";
          tbl.appendChild(tr);

          tblBody = document.createElement("tbody");

          if (_this.json_data_ff.length > 0)
            jQuery.each(_this.json_data_ff, function (i, val1) {
              var row = document.createElement("tr");

              let pomJ = 0;

              jQuery.each(val1, function (i, val) {
                var cell = document.createElement("td");

                var cellText;

                if (val === null || val === 0 || val === "")
                  cellText = document.createTextNode("-");
                else cellText = document.createTextNode(val);

                cell.appendChild(cellText);

                if (i === "Rb")
                  cell.setAttribute(
                    "style",
                    "text-align :center; padding-bottom: 4px; width: 10%;"
                  );
                else if (i === "Naziv")
                  cell.setAttribute(
                    "style",
                    "text-align :center; padding-bottom: 4px; width: 40%;"
                  );
                else if (_this.json_fields_type_ff[pomJ] === "Number") {
                  cell.setAttribute(
                    "style",
                    "text-align :right; padding-bottom: 4px; padding-right: 5px; width: 25%;"
                  );
                } else if (_this.json_fields_type_ff[pomJ] === "Date") {
                  cell.setAttribute(
                    "style",
                    "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px; width: 25%;"
                  );
                } else
                  cell.setAttribute(
                    "style",
                    "text-align :center; padding-bottom: 4px; width: 25%;"
                  );

                pomJ = pomJ + 1;

                row.appendChild(cell);
              });

              tblBody.appendChild(row);
            });
          else {
            var row = document.createElement("tr");
            for (let i = 0; i < 4; i++) {
              var cell = document.createElement("td");
              var cellText = document.createTextNode("-");

              cell.appendChild(cellText);

              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

              row.appendChild(cell);
            }

            tblBody.appendChild(row);
          }

          tbl.setAttribute("border", "thin solid");
          tbl.style.borderCollapse = "collapse";
          // tbl.style.borderColor = "black";

          tbl.appendChild(tblBody);

          tbl.style.margin = "0px 0px 0px 0px";
          tbl.style.width = "100%";

          elementToPrint.appendChild(tbl);

          /////////////////////////

          /////// Obrada zemljišta ///////

          var elementToPrint11 = document.createElement("p");

          elementToPrint11.innerHTML = "<br>Obrada zemljišta <br><br>";

          elementToPrint11.style.margin = "5px 0px 0px 0px";
          elementToPrint11.style.fontSize = "14px";
          elementToPrint.append(elementToPrint11);

          tbl = document.createElement("table");
          tr = document.createElement("tr"); // Header row
          jQuery.each(_this.json_fields_ff, function (i, val) {
            var th = document.createElement("th"); //column
            var text = "";
            text = document.createTextNode(i);

            th.setAttribute("style", "padding-bottom: 4px;");

            th.appendChild(text);

            tr.appendChild(th);
          });

          tr.style.background = "#eaece5";
          tbl.appendChild(tr);

          tblBody = document.createElement("tbody");

          if (_this.json_data_oz.length > 0)
            jQuery.each(_this.json_data_oz, function (i, val1) {
              var row = document.createElement("tr");

              let pomJ = 0;

              jQuery.each(val1, function (i, val) {
                var cell = document.createElement("td");

                var cellText;

                if (val === null || val === 0 || val === "")
                  cellText = document.createTextNode("-");
                else cellText = document.createTextNode(val);

                cell.appendChild(cellText);

                if (i === "Rb")
                  cell.setAttribute(
                    "style",
                    "text-align :center; padding-bottom: 4px; width: 10%;"
                  );
                else if (i === "Naziv")
                  cell.setAttribute(
                    "style",
                    "text-align :center; padding-bottom: 4px; width: 40%;"
                  );
                else if (_this.json_fields_type_ff[pomJ] === "Number") {
                  cell.setAttribute(
                    "style",
                    "text-align :right; padding-bottom: 4px; padding-right: 5px; width: 25%;"
                  );
                } else if (_this.json_fields_type_ff[pomJ] === "Date") {
                  cell.setAttribute(
                    "style",
                    "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px; width: 25%;"
                  );
                } else
                  cell.setAttribute(
                    "style",
                    "text-align :center; padding-bottom: 4px; width: 25%;"
                  );

                pomJ = pomJ + 1;

                row.appendChild(cell);
              });

              tblBody.appendChild(row);
            });
          else {
            var row = document.createElement("tr");
            for (let i = 0; i < 4; i++) {
              var cell = document.createElement("td");
              var cellText = document.createTextNode("-");

              cell.appendChild(cellText);

              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

              row.appendChild(cell);
            }

            tblBody.appendChild(row);
          }

          tbl.setAttribute("border", "thin solid");
          tbl.style.borderCollapse = "collapse";
          // tbl.style.borderColor = "black";

          tbl.appendChild(tblBody);

          tbl.style.margin = "0px 0px 0px 0px";
          tbl.style.width = "100%";

          elementToPrint.appendChild(tbl);

          /////////////////////////

          //////////Berba//////////
          var elementToPrint11 = document.createElement("p");

          elementToPrint11.innerHTML = "<br>Berba <br><br>";

          elementToPrint11.style.margin = "5px 0px 0px 0px";
          elementToPrint11.style.fontSize = "14px";
          elementToPrint.append(elementToPrint11);

          tbl = document.createElement("table");
          tr = document.createElement("tr"); // Header row
          jQuery.each(_this.json_fields_be, function (i, val) {
            var th = document.createElement("th"); //column
            var text = "";
            text = document.createTextNode(i);

            th.setAttribute("style", "padding-bottom: 4px;");

            th.appendChild(text);

            tr.appendChild(th);
          });

          tr.style.background = "#eaece5";
          tbl.appendChild(tr);

          tblBody = document.createElement("tbody");

          if (_this.json_data_be.length > 0)
            jQuery.each(_this.json_data_be, function (i, val1) {
              var row = document.createElement("tr");

              let pomJ = 0;

              jQuery.each(val1, function (i, val) {
                var cell = document.createElement("td");

                var cellText;

                if (val === null || val === 0 || val === "")
                  cellText = document.createTextNode("-");
                else cellText = document.createTextNode(val);

                cell.appendChild(cellText);

                if (i === 1)
                  cell.setAttribute(
                    "style",
                    "text-align :left; padding-left: 5px; padding-bottom: 4px;"
                  );
                else if (_this.json_fields_type_be[pomJ] === "Number") {
                  cell.setAttribute(
                    "style",
                    "text-align :right; padding-bottom: 4px; padding-right: 5px;"
                  );
                } else if (_this.json_fields_type_be[pomJ] === "Date") {
                  cell.setAttribute(
                    "style",
                    "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
                  );
                } else
                  cell.setAttribute(
                    "style",
                    "text-align :center; padding-bottom: 4px;"
                  );

                pomJ = pomJ + 1;

                row.appendChild(cell);
              });

              tblBody.appendChild(row);
            });
          else {
            var row = document.createElement("tr");
            for (let i = 0; i < 7; i++) {
              var cell = document.createElement("td");
              var cellText = document.createTextNode("-");

              cell.appendChild(cellText);

              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

              row.appendChild(cell);
            }

            tblBody.appendChild(row);
          }

          tbl.setAttribute("border", "thin solid");
          tbl.style.borderCollapse = "collapse";
          // tbl.style.borderColor = "black";

          tbl.appendChild(tblBody);

          tbl.style.margin = "0px 0px 0px 0px";
          tbl.style.width = "100%";

          elementToPrint.appendChild(tbl);

          /////////////////////////
          html2pdf(null, {
            margin: 1,
            // filename: item.number + ".pdf",
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { dpi: 300, scale: 2 },
            jsPDF: { unit: "cm", format: "a4" },
            // pagebreak: {
            //     mode: ['avoid-all', 'css', 'legacy']
            // }
            pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
          })
            .from(elementToPrint)
            .toPdf()
            .get("pdf")
            .then(function (pdf) {
              var totalPages = pdf.internal.getNumberOfPages();
              var i;

              for (i = 1; i <= totalPages; i++) {
                pdf.setPage(i);
                pdf.setFontSize(10);
                pdf.setTextColor(150);

                pdf.text(
                  getDateTime(),
                  0.9,
                  pdf.internal.pageSize.getHeight() - 0.5
                );

                pdf.text(
                  i + " od " + totalPages,
                  pdf.internal.pageSize.getWidth() / 1.075,
                  pdf.internal.pageSize.getHeight() - 0.5
                );
              }
              _this.isLoading = false;

              window.open(pdf.output("bloburl"), "_blank");
            });
        }, 10);
      }
    },
    getVineYards() {
      let url = "";

      url = this.globalServiceLocation + this.globalPort + "/vineyard/all";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.vineyard_items = response.data.filter(
            (e) => e.isExternVineyard === false
          );
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      this.vineyard_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllKartice() {
      this.isLoading = true;
      

      this.json_fields_type = [
        "String",
        "String",
        "String",
        "String",
        "String",
      ];

      this.json_fields_type_ff = ["String", "String", "String", "String"];
      this.json_fields_type_be = [
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
      ];

      let _this = this;

      this.vinogradiFilter = "";

      this.vinogradiFilter =
        this.vinogradiFilter + this.vineyard_select.name + ", ";

      this.filterSorti = "";

      this.filterSorti =
        this.filterSorti + this.grape_varieties_to_select.name + ", ";

      // let sortiranje = "";
      // if (this.paginationKartica.sortBy !== "") {
      //   let orderovanje = "";
      //   if (this.paginationKartica.descending) orderovanje = "desc";
      //   else orderovanje = "asc";

      //   sortiranje =
      //     "sort=" +
      //     this.paginationKartica.sortBy.replace("documentNumber", "number") +
      //     "&order=" +
      //     orderovanje;
      // }

      let urlLoc =
        "/vineyard_operation_execution/grape_variety_report/" +
        this.vineyard_select.id +
        "/" +
        this.grape_varieties_to_select.id +
        "/" +
        this.godina_select;

      //urlLoc = urlLoc + "?" + sortiranje;

      setTimeout(() => {
        this.$http
          .get(this.globalServiceLocation + this.globalPort + urlLoc, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            

            this.items_states_land_cultivations = [];
            this.items_states_basic = [];

            let niz_djubrenja = [];

            let rbrDj = 1;

            response.data.basicFertilizations.forEach(function (entry) {
              entry.vineyardOperationMaterials.forEach(function (e) {
                let obj = {
                  rbr: null,
                  id: null,
                  date: null,
                  name: null,
                  material: null,
                  quantity: null,
                };

                obj.id = entry.id;
                obj.rbr = rbrDj;
                obj.date = entry.date;
                obj.name = entry.vineyardOperation.name;
                obj.material = e.additive.name;
                obj.quantity = e.quantity + " " + e.unitOfMeasure.mark;

                niz_djubrenja.push(obj);

                rbrDj = rbrDj + 1;
              });
            });

            response.data.fertiligationFertilizations.forEach(function (entry) {
              entry.vineyardOperationMaterials.forEach(function (e) {
                let obj = {
                  rbr: null,
                  id: null,
                  date: null,
                  name: null,
                  material: null,
                  quantity: null,
                };

                obj.id = entry.id;
                obj.rbr = rbrDj;
                obj.date = entry.date;
                obj.name = entry.vineyardOperation.name;
                obj.material = e.additive.name;
                obj.quantity = e.quantity + " " + e.unitOfMeasure.mark;

                niz_djubrenja.push(obj);

                rbrDj = rbrDj + 1;
              });
            });

            response.data.foliarFertilizations.forEach(function (entry) {
              entry.vineyardOperationMaterials.forEach(function (e) {
                let obj = {
                  rbr: null,
                  id: null,
                  date: null,
                  name: null,
                  material: null,
                  quantity: null,
                };

                obj.id = entry.id;
                obj.rbr = rbrDj;
                obj.date = entry.date;
                obj.name = entry.vineyardOperation.name;
                obj.material = e.additive.name;
                obj.quantity = e.quantity + " " + e.unitOfMeasure.mark;

                niz_djubrenja.push(obj);

                rbrDj = rbrDj + 1;
              });
            });

            this.items_states_basic = niz_djubrenja.sort(function (a, b) {
              return a.id - b.id;
            });

            let niz_berbe = [];

            let sorta = this.grape_varieties_to_select.id;

            response.data.harvests.forEach(function (entry) {
              let datum = entry.date;

              entry.vineyardOperationHarvests.forEach(function (e) {
                if (e.vineyardOperationRows[0].grapeVariety.id === sorta) {
                  e.date = datum;
                  niz_berbe.push(e);
                }
              });
            });

            this.items_states_harvests = niz_berbe;

            this.items_states_pheno_phases = response.data.phenoPhases;

            let items_states_land_cultivations_pom = [];
            items_states_land_cultivations_pom =
              response.data.landCultivations.sort(function (a, b) {
                return a.vineyardOperation.id - b.vineyardOperation.id;
              });

            let pom_pom_niz = [];

            items_states_land_cultivations_pom.forEach(function (entry) {
              let ind_pom = -1;

              if (pom_pom_niz.length >= 0)
                ind_pom = pom_pom_niz.findIndex(
                  (x) => x.vineyardOperationid === entry.vineyardOperation.id
                );

              if (ind_pom >= 0) pom_pom_niz[ind_pom].to = entry.date;
              else {
                let obj = {
                  id: entry.id,
                  name: entry.vineyardOperation.name,
                  from: entry.date,
                  to: entry.date,
                  vineyardOperationid: entry.vineyardOperation.id,
                };

                pom_pom_niz.push(obj);
              }
            });

            this.items_states_land_cultivations = pom_pom_niz;

            this.planting_years = response.data.plantingYears.join(", ");
            this.pruning_type = response.data.pruningType;
            this.breeding_type = response.data.breedingType;

            this.json_data = [];
            let rbr = 1;

            this.items_states_basic.forEach(function (entry) {
              let objekat = {
                Rb: rbr,
                Datum: _this.formatDateTime(entry.date),
                Naziv: entry.name,
                Material: entry.material,
                Količina: entry.quantity,
              };

              _this.json_data.push(objekat);

              rbr = rbr + 1;
            });

            this.json_data_ff = [];
            rbr = 1;

            this.items_states_pheno_phases.forEach(function (entry) {
              let objekat = {
                Rb: rbr,
                Naziv: entry.name,
                Početak: _this.formatDateTime(entry.from),
                Kraj: _this.formatDateTime(entry.to),
              };

              _this.json_data_ff.push(objekat);

              rbr = rbr + 1;
            });

            this.json_data_oz = [];
            rbr = 1;

            this.items_states_land_cultivations.forEach(function (entry) {
              let objekat = {
                Rb: rbr,
                Naziv: entry.name,
                Početak: _this.formatDateTime(entry.from),
                Kraj: _this.formatDateTime(entry.to),
              };

              _this.json_data_oz.push(objekat);

              rbr = rbr + 1;
            });

            this.json_data_be = [];
            rbr = 1;

            this.items_states_harvests.forEach(function (entry) {
              let objekat = {
                Rb: rbr,
                Datum: _this.formatDateTime(entry.date),
                Količina: entry.quantity + " kg",
                Površina:
                  entry.surface > 1000
                    ? _this.currencyFormatDE4(entry.surface / 10000) + " ha"
                    : _this.currencyFormatDE4(Math.round(entry.surface) / 100) +
                      " ar",
                Prinos:
                  _this.currencyFormatDE3(
                    entry.quantity / (entry.surface / 10000)
                  ) + " kg/ha",
                Šećer: entry.sugar !== null ? entry.sugar + " °Oe" : "-",
                Kiselina: entry.acid !== null ? entry.acid + " g/l" : "-",
              };

              _this.json_data_be.push(objekat);

              rbr = rbr + 1;
            });
            this.isLoading = false;
          })
          .catch((e) => {
            if (!e.response) {
              this.isLoading = false;

              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation + this.globalPort + urlLoc,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.items_states_land_cultivations = [];
                        this.items_states_basic = [];

                        let niz_djubrenja = [];

                        let rbrDj = 1;

                        response.data.basicFertilizations.forEach(function (
                          entry
                        ) {
                          entry.vineyardOperationMaterials.forEach(function (
                            e
                          ) {
                            let obj = {
                              rbr: null,
                              id: null,
                              date: null,
                              name: null,
                              material: null,
                              quantity: null,
                            };

                            obj.id = entry.id;
                            obj.rbr = rbrDj;
                            obj.date = entry.date;
                            obj.name = entry.vineyardOperation.name;
                            obj.material = e.additive.name;
                            obj.quantity =
                              e.quantity + " " + e.unitOfMeasure.mark;

                            niz_djubrenja.push(obj);

                            rbrDj = rbrDj + 1;
                          });
                        });

                        response.data.fertiligationFertilizations.forEach(
                          function (entry) {
                            entry.vineyardOperationMaterials.forEach(function (
                              e
                            ) {
                              let obj = {
                                rbr: null,
                                id: null,
                                date: null,
                                name: null,
                                material: null,
                                quantity: null,
                              };

                              obj.id = entry.id;
                              obj.rbr = rbrDj;
                              obj.date = entry.date;
                              obj.name = entry.vineyardOperation.name;
                              obj.material = e.additive.name;
                              obj.quantity =
                                e.quantity + " " + e.unitOfMeasure.mark;

                              niz_djubrenja.push(obj);

                              rbrDj = rbrDj + 1;
                            });
                          }
                        );

                        response.data.foliarFertilizations.forEach(function (
                          entry
                        ) {
                          entry.vineyardOperationMaterials.forEach(function (
                            e
                          ) {
                            let obj = {
                              rbr: null,
                              id: null,
                              date: null,
                              name: null,
                              material: null,
                              quantity: null,
                            };

                            obj.id = entry.id;
                            obj.rbr = rbrDj;
                            obj.date = entry.date;
                            obj.name = entry.vineyardOperation.name;
                            obj.material = e.additive.name;
                            obj.quantity =
                              e.quantity + " " + e.unitOfMeasure.mark;

                            niz_djubrenja.push(obj);

                            rbrDj = rbrDj + 1;
                          });
                        });

                        this.items_states_basic = niz_djubrenja.sort(function (
                          a,
                          b
                        ) {
                          return a.id - b.id;
                        });

                        let niz_berbe = [];

                        let sorta = this.grape_varieties_to_select.id;

                        response.data.harvests.forEach(function (entry) {
                          let datum = entry.date;

                          entry.vineyardOperationHarvests.forEach(function (e) {
                            if (
                              e.vineyardOperationRows[0].grapeVariety.id ===
                              sorta
                            ) {
                              e.date = datum;
                              niz_berbe.push(e);
                            }
                          });
                        });

                        this.items_states_harvests = niz_berbe;

                        this.items_states_pheno_phases =
                          response.data.phenoPhases;

                        let items_states_land_cultivations_pom = [];
                        items_states_land_cultivations_pom =
                          response.data.landCultivations.sort(function (a, b) {
                            return (
                              a.vineyardOperation.id - b.vineyardOperation.id
                            );
                          });

                        let pom_pom_niz = [];

                        items_states_land_cultivations_pom.forEach(function (
                          entry
                        ) {
                          let ind_pom = -1;

                          if (pom_pom_niz.length !== 0)
                            pom_pom_niz.findIndex(
                              (x) =>
                                x.vineyardOperation.id ===
                                entry.vineyardOperation.id
                            );

                          if (ind_pom >= 0)
                            pom_pom_niz(ind_pom).to = entry.date;
                          else {
                            let obj = {
                              id: entry.id,
                              name: entry.vineyardOperation.name,
                              from: entry.date,
                              to: entry.date,
                            };

                            pom_pom_niz.push(obj);
                          }
                        });

                        this.items_states_land_cultivations = pom_pom_niz;

                        this.planting_years =
                          response.data.plantingYears.join(", ");
                        this.pruning_type = response.data.pruningType;
                        this.breeding_type = response.data.breedingType;

                        this.json_data = [];
                        let rbr = 1;

                        this.items_states_basic.forEach(function (entry) {
                          let objekat = {
                            Rb: rbr,
                            Datum: _this.formatDateTime(entry.date),
                            Naziv: entry.name,
                            Material: entry.material,
                            Količina: entry.quantity,
                          };

                          _this.json_data.push(objekat);

                          rbr = rbr + 1;
                        });

                        this.json_data_ff = [];
                        rbr = 1;

                        this.items_states_pheno_phases.forEach(function (
                          entry
                        ) {
                          let objekat = {
                            Rb: rbr,
                            Naziv: entry.name,
                            Početak: _this.formatDateTime(entry.from),
                            Kraj: _this.formatDateTime(entry.to),
                          };

                          _this.json_data_ff.push(objekat);

                          rbr = rbr + 1;
                        });

                        this.json_data_oz = [];
                        rbr = 1;

                        this.items_states_land_cultivations.forEach(function (
                          entry
                        ) {
                          let objekat = {
                            Rb: rbr,
                            Naziv: entry.name,
                            Početak: _this.formatDateTime(entry.from),
                            Kraj: _this.formatDateTime(entry.to),
                          };

                          _this.json_data_oz.push(objekat);

                          rbr = rbr + 1;
                        });

                        this.json_data_be = [];
                        rbr = 1;

                        this.items_states_harvests.forEach(function (entry) {
                          let objekat = {
                            Rb: rbr,
                            Datum: _this.formatDateTime(entry.date),
                            Količina: entry.quantity + " kg",
                            Površina:
                              entry.surface > 1000
                                ? _this.currencyFormatDE4(
                                    entry.surface / 10000
                                  ) + " ha"
                                : _this.currencyFormatDE4(
                                    Math.round(entry.surface) / 100
                                  ) + " ar",
                            Prinos:
                              _this.currencyFormatDE3(
                                entry.quantity / (entry.surface / 10000)
                              ) + " kg/ha",
                            Šećer:
                              entry.sugar !== null ? entry.sugar + " °Oe" : "-",
                            Kiselina:
                              entry.acid !== null ? entry.acid + " g/l" : "-",
                          };

                          _this.json_data_be.push(objekat);

                          rbr = rbr + 1;
                        });
                        this.isLoading = false;
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }, 10);
    },
    currencyFormatDE(num) {
      return num
        .toFixed(2) // always two decimal digits
        .replace(".", ",") // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
    },
    getGrapeVarieties(e) {
      if (e === undefined) this.grape_varieties_to_items = [];
      else {
        let url = "/vineyard/" + e.id + "/grape_varietis?";

        this.$http
          .get(this.globalServiceLocation + this.globalPort + url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            this.grape_varieties_to_items = response.data;
          })
          .catch((e) => {
            // // console.log(e.response);

            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    // // console.log(result);
                    // // console.log("Novi token - " + localStorage.getItem("user-token"));

                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/grape_variety/all",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        // // console.log(response.data);

                        this.grape_varieties_to_items = response.data;
                      })
                      .catch((e) => {
                        // // console.log(e.response);

                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }
    },
    clear() {
      this.$refs.form.reset();

      this.vinogradiFilter = "";
      this.filterSorti = "";

      this.godina_select = undefined;
      this.vineyard_select = undefined;
      this.grape_varieties_to_select = undefined;

      this.items_states_land_cultivations = [];

      this.planting_years = undefined;
      this.pruning_type = undefined;
      this.breeding_type = undefined;

      this.items_states_basic = [];
      this.items_states_harvests = [];
      this.items_states_pheno_phases = [];

      this.json_data_oz = [];
      this.json_data_ff = [];
      this.json_data_be = [];
      this.json_data = [];
    },
    // changeSortKartica(column) {
    //   if (this.items_states_basic.length > 0)
    //     if (typeof column !== "undefined")
    //       if (column !== "funkcije")
    //         if (this.paginationKartica.sortBy === column) {
    //           this.paginationKartica.descending =
    //             !this.paginationKartica.descending;
    //         } else {
    //           this.paginationKartica.sortBy = column;
    //           this.paginationKartica.descending = false;
    //         }
    // },
  },
  mounted() {
    this.clear();
    // this.getGrapeVarieties();
    this.getYears();
    this.getVineYards();
  },

beforeMount() {
  this.vinarija = daLiJeVinarija(localStorage.getItem("isWinery"));

  if(!this.vinarija){
    this.labVinograd = "Zasad";
    this.naslov = "Izveštaj zasada";
  }
  else
  {
    this.labVinograd = "Vinograd";
    this.naslov = "Vinogradarski izveštaj";
  }
}
};
</script>

<style scoped lang='scss'>
@import "./parts/../../assets/sass/parts/modalStyles_siri_modal";

div.layout.row.wrap {
  padding-top: 20px !important;
  max-height: 90px !important;
}

.topics tr {
  line-height: 14px;
}

.topics {
  margin-left: 10%;
  border-collapse: collapse;
  border-spacing: 0;
  width: 90%;
}

.topics th {
  height: 25px;
  font-weight: 500;
  font-size: 12px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.topics td {
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

.menuable__content__active {
  background-color: white;
}

.zaglavlje {
  padding-top: 10px;
  color: rgba(0, 0, 0, 0.54);
  font-size: larger;
  padding-left: 8px;
  padding-right: 8px;
}
.zaglavlje_2 {
  padding-top: 20px;
  color: rgba(0, 0, 0, 0.54);
  font-size: larger;
}
.zaglavlje_3 {
  padding-top: 20px;
  color: rgba(0, 0, 0, 0.54);
  font-size: larger;
  padding-left: 8px;
  padding-right: 8px;
}
.text {
  color: rgba(0, 0, 0, 0.54);
  font-size: larger;
  padding-left: 8px;
  padding-right: 8px;
}
</style>